import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getRestrictedSubCategories } from "./api/restrictedPageApis";
import Home from "pages/Home";
import { Card } from "components/ui";
import { Grid, Typography } from "@mui/material";
import LoadingSmallCard from "components/ui/Skeleton/LoadingSmallCard";
import { encodeStr } from "utils/encodeDecodeStr";
import { useSettingContext } from "context/SettingContext";
import { useGlobalContext } from "context/GlobalContext";
import { useFilter } from "context/FilterContext";
import DataNotFound from "components/ui/datanotfound/DataNotFound";

function RestrictedDesignSubCategoryPage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [subCategoryTotalCount, setSubCategoryTotalCount] = useState(null);
  const location = useLocation();
  const [isReady, setIsReady] = useState(false);

  const navigate = useNavigate();
  const { setSearch, setSearchBar, search } = useSettingContext();
  const { setFilterChangeCount, setDisplayCount, setFilterChangeDesignCount, setSearchPlaceHolder, setSearchResultCount, setDynamicFilterCount } = useGlobalContext();
  const { setFilterCount } = useFilter();

  const handleClick = (data) => {
    setFilterChangeCount(0);
    const state = {
      ...location.state,
      name: [`${location?.state?.name[0]}`, `${location?.state?.name[1]}`, `${data?.subCategory}`],
      restrictedSubCatgeorySearch: search !== "" ? search : "",
    };
    navigate(`/Setting/restricted-designs/${encodeStr(location?.state?.name[1])}/${encodeStr(data?.subCategory)}`, { state });
  };

  useEffect(() => {
    setSearchBar(true);
    setSearchPlaceHolder("Search By Category or Design Number");
    setFilterCount(0);
    return () => {
      setSearchBar(false);
      setSearch("");
      setSearchPlaceHolder("");
      setFilterChangeDesignCount(0);
      setFilterCount(0);
      setSearchResultCount(0);
      setFilterChangeCount(0);
      setDynamicFilterCount(true);
    };
  }, []);

  useEffect(() => {
    if (!isReady) return;
    const fetchRestrictedSubCategories = async () => {
      let payload = {
        categoryName: location?.state?.name[1],
        searchTerm: search,
      };
      let response = await getRestrictedSubCategories(payload);

      if (response.status === 200) {
        // let categoryName = response.message.split(":")[1];

        setData(response.subCategories);
        setSubCategoryTotalCount(response.totalUniqueSubCategoryCount);

        if (search !== "") {
          setSearchResultCount(response.totalUniqueSubCategoryCount);
          setFilterChangeCount(response.totalUniqueSubCategoryCountAll);
        } else {
          setFilterChangeCount(response.totalUniqueSubCategoryCount);
        }

        setLoading(false);
      } else {
        alert("something went wrong");
      }
    };
    fetchRestrictedSubCategories();
  }, [search, isReady]);

  useEffect(() => {
    // setFilterChangeCount(subCategoryTotalCount);
    // setFilterChangeDesignCount(data?.pages[0]?.totalStyles);
    setDisplayCount(true);
    return () => {
      // setFilterChangeCount(0);
      // setFilterChangeDesignCount(0);
      setDisplayCount(false);
    };
  }, [data]);

  useEffect(() => {
    setSearch(location?.state?.restrictedSubCatgeorySearch || "");
    setIsReady(true);
  }, [location]);

  if (loading) return <LoadingSmallCard count={24} />;

  const hasNoResults =
    search &&
    !data?.length

  if (hasNoResults) return <DataNotFound message={`No results found for "${search}"`} />;

  return (
    <>
      {data && data.length > 0 ? (
        <Grid
          container
          className="Grid-padding"
          direction="row"
          justifyContent="flex-start"
          sx={{
            flex: "1 1 1",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: "30px",
            rowGap: "32px",
          }}
        >
          {data &&
            data.map((ele, i) => (
              <Grid item key={i} onClick={() => handleClick(ele)}>
                <Card style={{ minWidth: 275, maxWidth: "317px", height: 62, borderRadius: "5px" }}>
                  <Typography mr={"auto"} fontSize={"20px"} fontWeight={400} fontFamily={"Karla"}>
                    {ele.subCategory}
                  </Typography>
                  <Typography ml={"auto"} fontSize={"20px"} fontWeight={400} fontFamily={"Karla"}>
                    {ele.count}
                  </Typography>
                </Card>
              </Grid>
            ))}
        </Grid>
      ) : (
        <Home />
      )}
    </>
  );
}

export default RestrictedDesignSubCategoryPage;
